import axios from '../axios-config';
import { updateAdminOrder } from '../auth/sales-login.server';

/*
===============================|> All Checkout APis <|===============================
01 |--> get Regions,
02 |--> get User addresses,
03 |--> get available shipping methods,
04 |--> add bundle products to cart,
05 |--> get available payments,
===============================|> All Checkout APis <|===============================
*/

const getRegions = async () => {
  let config = {
    method: 'get',
    url: '/customer/getCities',
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getRegionsV2 = async (locale = 'ar') => {
  let config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/mstore/region/${locale}`,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02- ============= get regions data
const getUserAddresses = async (mage) => {
  let config = {
    method: 'get',
    url: '/customer/address',
    headers: {
      mage: 'Bearer ' + mage,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getShippingValues = (shipping_address) => {
  let shipping_custom_attributes = [];
  if (shipping_address.nationalAddress) {
    shipping_custom_attributes.push({
      attribute_code: 'national_address',
      value: shipping_address.nationalAddress,
    });
  }
  if (shipping_address.deliveryInstruction) {
    shipping_custom_attributes.push({
      attribute_code: 'delivery_instructions',
      value: shipping_address.deliveryInstruction,
    });
  }
  return {
    region: shipping_address?.region,
    region_id: shipping_address?.region_id,
    country_id: 'SA',
    street: shipping_address?.street,
    postcode: shipping_address?.postcode,
    city: shipping_address?.city,
    firstname: shipping_address?.firstname,
    lastname: '',
    email: shipping_address?.email,
    telephone: shipping_address?.telephone,
    ...(shipping_custom_attributes?.length > 0 && {
      custom_attributes: shipping_custom_attributes,
    }),
  };
};

// 04- ============= get Shipping Address
const setShippingAddress = async (
  mage,
  quote,
  address,
  shipping_method,
  am_pickup
) => {
  address.telephone = address.telephone.replace(/^00/, '');
  delete address?.short_address;
  const shipping_address = address;
  const isSave = address?.isSave;
  isSave && delete address.isSave;
  if (address?.name) {
    address.firstname = address?.name?.split(' ')[0];
    address.lastname = '';
    delete address.name;
  }
  const billing_address = {
    ...address,
    ...(mage && isSave ? { save_in_address_book: 1 } : {}),
  };

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();
  const date = `${year}-${month + 1}-${day}`;

  let data = {
    addressInformation: {
      shipping_address: getShippingValues(shipping_address),
      billing_address: getShippingValues(billing_address),
      shipping_carrier_code: shipping_method,
      shipping_method_code: shipping_method,
    },
  };
  if (am_pickup !== null) {
    data.addressInformation.extension_attributes = {};
    data.addressInformation.extension_attributes.am_pickup = {
      store_id: am_pickup,
      date,
      time_from: now.getTime() + 3 * 60 * 60 * 1000,
      time_to: now.getTime() + 4 * 60 * 60 * 1000,
    };
  }

  let config = {
    method: 'post',
    url: '/cart/shippingaddress',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify(data),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const placeOrder = async (mage, quote, method, email) => {
  let data = {
    email,
    paymentMethod: {
      method,
    },
  };

  let config = {
    method: 'post',
    url: '/cart/createOrder',

    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify(data),
  };
  try {
    const req = await axios(config);
    if (req?.data?.data) {
      updateAdminOrder({ orderId: req.data.data }).catch((err) =>
        console.error('Failed to trigger admin order update:', err)
      );
    }
    return req;
  } catch (error) {
    return error;
  }
};

const cardPin = async (mage, quote, firstSixCardNums) => {
  let data = {
    cardPin: firstSixCardNums,
    cartId: quote,
    isMask: mage ? '0' : '1',
  };

  let config = {
    method: 'post',
    url: '/mstore/card-pin',

    data: JSON.stringify(data),
  };
  if (mage) {
    config.headers.mage = 'Bearer ' + mage;
  }
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used in checkout page
// const getShippingMethods = async (region_id, mage, quote) => {
const getShippingMethods = async (coordinates, mage, quote) => {
  let config = {
    method: 'POST',
    // url: `/mstore/available-shipping-methods/${region_id}/${mage ? '0' : '1'}`,
    url: '/customer/shipping-methods-by-location',
    headers: {
      quote: `Bearer ${quote}`,
    },
    data: JSON.stringify({
      location: {
        lat: coordinates?.lat,
        long: coordinates?.lng,
        region_id: coordinates?.region_id,
        city_id: coordinates?.city_id,
      },
      cart_id: quote,
      is_mask: mage ? false : true,
    }),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// used in checkout page
const setPaymentMethod = async (quote, mage, paymentMethod, email) => {
  let config = {
    method: 'post',
    url: '/cart/setpaymentmethod',
    headers: {
      quote: `Bearer ${quote}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({
      cartId: quote,
      paymentMethod: {
        method: paymentMethod,
      },
      email,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const activeCart = async (order_id) => {
  let config = {
    method: 'post',
    url: '/cart/active',
    data: JSON.stringify({ order_id, device: 'web' }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const availableToCheckout = async (
  lat,
  long,
  region_id,
  city_id,
  mage,
  quote,
  delivery_type = 'home_delivery'
) => {
  let config = {
    method: 'POST',
    url: `/customer/checkout-availability-by-location-v2`,
    headers: {
      quote: `Bearer ${quote}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },

    data: JSON.stringify({
      cart_id: quote,
      location: {
        lat,
        long,
        region_id,
        city_id,
      },
      delivery_type,
      is_mask: mage ? false : true,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export const getNearestBranches = async (lat, long) => {
  let config = {
    method: 'POST',
    url: `/branch/near-me`,
    data: JSON.stringify({
      location: {
        lat,
        long,
      },
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const sendLoyaltyPointsOtp = async (mobilenumber) => {
  const data = JSON.stringify({
    mobilenumber,
    otptype: 'checkout',
    email: '',
    resendotp: '',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/register/otp/send',
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const verifyLoyaltyPointsOtp = async (mobilenumber, otpcode) => {
  const data = JSON.stringify({
    mobilenumber,
    otpcode,
    otptype: 'checkout',
    oldmobile: '',
  });
  const config = {
    method: 'post',
    url: '/customer/register/otp/verify',
    data,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getLoyaltyPointsBalance = async (mobileNumber, mage) => {
  const config = {
    method: 'post',
    url: '/rabah/balance-check',
    data: JSON.stringify({
      mobileNumber: `0${mobileNumber?.slice(-9)}`,
    }),
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const createLoyaltyAccount = async (body, mage) => {
  const data = JSON.stringify({
    rabah: body,
  });
  const config = {
    method: 'post',
    url: '/rabah/create-account',
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const redeemLoyaltyPoints = async ({ points, quote, mage, mobileNumber }) => {
  const data = JSON.stringify({
    points,
    cart_id: quote,
    is_mask: mage ? false : true,
    mobileNumber,
  });

  const config = {
    method: 'post',
    url: '/rabah/redeem',
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const cancelRedeemLoyaltyPoints = async (quote, mage) => {
  const data = JSON.stringify({
    cart_id: quote,
    is_mask: mage ? false : true,
  });

  const config = {
    method: 'post',
    url: '/rabah/redeem-cancel',
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data,
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getUserBalance = async (mage) => {
  let config = {
    method: 'GET',
    url: '/store-credit/credit',
    headers: {
      mage: `Bearer ${mage}`,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getUserLoyaltyPoints = async (mage, mobileNumber) => {
  let config = {
    method: 'POST',
    url: '/rabah/balance-check',
    headers: {
      mage: `Bearer ${mage}`,
    },
    data: JSON.stringify({
      mobileNumber: `0${mobileNumber?.slice(-9)}`,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const handleApplyUserCredit = async ({ mage, quote, amount }) => {
  let config = {
    method: 'POST',
    url: '/store-credit/apply',
    headers: {
      mage: `Bearer ${mage}`,
      quote: `Bearer ${quote}`,
    },
    data: JSON.stringify({
      cart_id: quote,
      amount,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
const handleCancelUserCredit = async ({ mage, quote }) => {
  let config = {
    method: 'POST',
    url: '/store-credit/cancel',
    headers: {
      mage: `Bearer ${mage}`,
      quote: `Bearer ${quote}`,
    },
    data: JSON.stringify({ cart_id: quote }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const misPayCrateOrder = async (order_id) => {
  let data = {
    order_id,
  };

  let config = {
    method: 'post',
    url: '/mispay/create-order',

    data: JSON.stringify(data),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const madfuCrateOrder = async (order_id) => {
  let config = {
    method: 'post',
    url: '/madfu/create-order',

    data: JSON.stringify({ order_id }),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};
const paymentSmsSendLink = async (order_id, payment_link) => {
  let config = {
    method: 'post',
    url: '/payment-link',
    data: JSON.stringify({ order_id, payment_link }),
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getAdminPaymentMethods = async () => {
  let config = {
    method: 'get',
    url: '/customer/admin-payment-methods',
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getRegions,
  getRegionsV2,
  getUserAddresses,
  setShippingAddress,
  placeOrder,
  cardPin,
  getShippingMethods,
  setPaymentMethod,
  activeCart,
  sendLoyaltyPointsOtp,
  verifyLoyaltyPointsOtp,
  getLoyaltyPointsBalance,
  createLoyaltyAccount,
  redeemLoyaltyPoints,
  cancelRedeemLoyaltyPoints,
  getUserBalance,
  handleApplyUserCredit,
  handleCancelUserCredit,
  getUserLoyaltyPoints,
  misPayCrateOrder,
  madfuCrateOrder,
  paymentSmsSendLink,
  getAdminPaymentMethods,
};
